import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Kundorder } from "~app/features/forsaljning/models/KundorderListResponseDTO";
import { TerminalSearchResultViewModel } from "./terminal-search-result-view-model";

@Component({
    selector: "rask-terminalorder-list",
    templateUrl: "./terminalorder-list.component.html",
    styleUrls: ["./terminalorder-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        TranslatePipe
    ]
})
export class TerminalorderListComponent {
    terminalordrar: TerminalSearchResultViewModel[];

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("terminalordrar") set list(val: Kundorder[]) {
        if (!val) {
            return;
        }
        this.terminalordrar = val.map(x => new TerminalSearchResultViewModel(x));
    }
}
